<template>
   <div class="task-table-row" :class="{ 'task-table-row--alt': isAlt, 'task-table-row--has-ticket-time': task.lastTicketDateTime }" @click="goToTaskLogs">
      <span class="cell cell--id">{{ requestCode }}</span>
      <span class="cell">{{ route }} </span>
      <span class="cell">{{ task.groupPnrDetails && task.groupPnrDetails.departureDate | FormatterDate }}</span>
      <span class="cell">{{ task.groupPnrDetails && task.groupPnrDetails.returnDate | FormatterDate }}</span>
      <span class="cell">{{ cabinLabel }}</span>
      <span class="cell">
         <span class="passenger-badge">{{ totalPassengerCount }}</span>
      </span>
      <span class="cell">
         <TaskRequestStatusBadge :status="task.status" :label="task.status | ETaskStatus" class-prefix="ETaskStatus" />
      </span>
      <span class="cell">
         <span :class="task.groupPnrDetails && task.groupPnrDetails.lastTicketDateTime ? 'last-ticket-date-time' : ''">
            {{ task.groupPnrDetails && task.groupPnrDetails.lastTicketDateTime | FormatterDD_MM_YYYY_HH_mm }}</span
         >
      </span>
   </div>
</template>

<script>
import TaskRequestStatusBadge from "./TaskRequestStatusBadge.vue";

const SUB_STATUS_VARIANT = {
   1: "gray",
   2: "gray",
   3: "gray",
   4: "gray",
   5: "gray",
   6: "red",
   7: "green",
   8: "green",
   9: "gray",
};

export default {
   name: "TaskRequestTableRow",
   components: { TaskRequestStatusBadge },
   props: {
      task: { type: Object, required: true },
      isAlt: { type: Boolean, default: false },
   },
   computed: {
      totalPassengerCount() {
         const paxCounts = this.task.groupPnrDetails?.paxCounts;
         if (!paxCounts) return "-";
         const total = (paxCounts.ADULT || 0) + (paxCounts.CHILD || 0) + (paxCounts.INFANT || 0);
         return total;
      },
      requestCode() {
         // const dep = this.task.groupPnrDetails?.departureAirport || "";
         return `${this.task.id}`;
      },
      route() {
         const d = this.task.groupPnrDetails;
         if (!d) return "-";
         return `${d.departureAirport} - ${d.arrivalAirport}`;
      },
      cabinLabel() {
         const cabinType = this.task.groupPnrDetails?.cabinType;
         const cabinMap = {
            1: "enum_economy",
            2: "enum_business",
            3: "enum_first",
         };
         return cabinMap[cabinType] ? this.$t(cabinMap[cabinType]) : "-";
      },
      statusVariant() {
         return SUB_STATUS_VARIANT[this.task.subStatus] || "gray";
      },
      statusLabel() {
         const statusMap = {
            1: "taskRequestList_statusNew",
            2: "taskRequestList_statusInProgress",
            3: "taskRequestList_statusWaitingResponse",
            4: "taskRequestList_statusWaitingResponse",
            5: "taskRequestList_statusWaitingResponse",
            6: "taskRequestList_statusClosed",
            7: "taskRequestList_statusApproved",
            8: "taskRequestList_statusApproved",
            9: "taskRequestList_statusReopened",
         };
         return statusMap[this.task.subStatus] ? this.$t(statusMap[this.task.subStatus]) : this.$t("common_unknown");
      },
   },
   methods: {
      goToTaskLogs() {
         if (this.task.orderId > 0) {
            const route = this.$router.resolve({
               path: `/order/detail/${this.task.orderUuid}`,
            });
            window.open(route.href, "_blank");
         } else {
            this.$router.push({
               path: `/group/flight/tasks/${this.task.id}`,
               query: {
                  taskId: this.task.id,
                  orderId: this.task.orderId || 0,
               },
            });
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.task-table-row {
   display: grid;
   grid-template-columns: 1fr 0.75fr 1fr 1fr 0.85fr 0.75fr 0.75fr 1.25fr;
   align-items: center;
   padding: 20px 16px;
   border-bottom: 1px solid var(--border-subtle);
   cursor: pointer;
   transition: background-color 0.2s;

   &:hover {
      background-color: var(--state-hover);
   }

   &--alt {
      background-color: var(--surface-level-2);

      &:hover {
         background-color: var(--state-active);
      }
   }

   .cell {
      font-size: 14px;
      color: var(--txt-color);
      font-weight: 400;

      &--id {
         font-weight: 600;
      }

      .last-ticket-date-time {
         font-weight: 700;
         background-color: var(--orange-100);
         color: var(--orange-600);
         padding: 0.25rem 0.5rem;
         border-radius: 0.25rem;
         white-space: nowrap;
      }
   }

   .passenger-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 8px;
      height: 20px;
      border-radius: 4px;
      background-color: var(--gray-200);
      color: var(--gray-500);
      font-size: 12px;
      font-weight: 600;
   }
}
</style>
